import { Injectable } from '@angular/core';

import { SchedulePriority } from '../shared/services/scheduler.service';
import { LazyLoadableModuleId } from './lazy-loadable-module-id.enum';

// TODO: Based on different scenarios, we can supply different priorities.
// This implementation is a starting point, but should be more robust so that it can
// adapt to current the route and user-specific page capabilities.
@Injectable({
    providedIn: 'root'
})
export class ModulePriorityService {
    public getSchedulePriority(moduleId: LazyLoadableModuleId): SchedulePriority {
        switch (moduleId) {
            case LazyLoadableModuleId.AppBar:
            case LazyLoadableModuleId.AppGalleryAngular:
            case LazyLoadableModuleId.AppGalleryReact:
            case LazyLoadableModuleId.CreateOnHome:
            case LazyLoadableModuleId.Edgeworth:
            case LazyLoadableModuleId.EdgeworthReact:
            case LazyLoadableModuleId.FluentThemeProvider:
            case LazyLoadableModuleId.LearningShelfReact:
            case LazyLoadableModuleId.LeftNavReact:
            case LazyLoadableModuleId.Mru:
            case LazyLoadableModuleId.NewConsumerExperience:
            case LazyLoadableModuleId.NewUserShelf:
            case LazyLoadableModuleId.QuickAccess:
            case LazyLoadableModuleId.RecommendedReact:
            case LazyLoadableModuleId.WorkspaceNav:
                return SchedulePriority.Immediate;
            case LazyLoadableModuleId.AutoSuggest:
            case LazyLoadableModuleId.Install:
            case LazyLoadableModuleId.InstallReact:
            case LazyLoadableModuleId.CreateCenter:
            case LazyLoadableModuleId.CreateCenterReact:
            case LazyLoadableModuleId.CreateMenu:
            case LazyLoadableModuleId.FirstRun:
            case LazyLoadableModuleId.FirstRunReact:
            case LazyLoadableModuleId.FirstRunWrapper:
            case LazyLoadableModuleId.Places:
            case LazyLoadableModuleId.UploadButton:
            case LazyLoadableModuleId.WelcomeBadgeReact:
                return SchedulePriority.High;
            case LazyLoadableModuleId.UploadDialog:
            case LazyLoadableModuleId.Banner:
            case LazyLoadableModuleId.FluidContent:
            case LazyLoadableModuleId.WacContent:
                return SchedulePriority.Medium;
            default:
                return SchedulePriority.Low;
        }
    }
}
